/* eslint-disable camelcase */
export default {
  email_not_unique: "A user with this email already exists",
  phone_not_unique: "A user with this phone number already exists",
  account_created: "Account created successfully",
  id_of_created_user: "ID of created user",
  unknown_uniqueness_error: "An unknown error occurred while checking uniqueness",
  unknown_create_error: "An unknown error occurred while creating an account",
};
